import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getDocumentsList,
  getFileUploadSignedUrl,
  getViewFileSignedUrl,
  getDownloadSignedUrl,
  getDeleteSignedUrl,
  getSignedUrlList,
  postSavedUploadedFile,
  getUploadedFileById,
  deleteFileById,
  submitDocument,
  consentFormStep,
  getViewFileROWSignedUrl,
} from "../../services/apiEndPoints";
import { StepIconClassKey } from "@mui/material";

type DocumentsListPayload = {
  category_id: number;
  access_id: any;
};

type DocumentsPayload = {
  category_id: number;
  access_id: any;
  document: string;
};

type FormStepPayload = {
  access_id: number;
};

export const getDocumentsListThunk = createAsyncThunk(
  "access/getDocumentsList",
  async (payload: DocumentsPayload) => {
    const { category_id, access_id, document } = payload;
    try {
      const response = await getDocumentsList(category_id, access_id, document);
      return response.data;
    } catch (error: any) {
      return error;
    }
  },
);

export const getFileUploadSignedURLThunk = createAsyncThunk(
  "access/getFileUploadSignedURL",
  async ({
    fileName,
    fileSize,
    contentType,
    isEsign,
  }: {
    fileName: string;
    fileSize: string;
    contentType: string;
    isEsign?: boolean;
  }) => {
    try {
      const response = await getFileUploadSignedUrl(
        fileName,
        fileSize,
        contentType,
        isEsign,
      );
      return response.data;
    } catch (error: any) {
      return error;
    }
  },
);

export const getFileSignedURLThunk = createAsyncThunk(
  "access/getFileSignedURL",
  async ({ document_name }: { document_name: string }) => {
    try {
      const response = await getViewFileSignedUrl(document_name);
      return response.data;
    } catch (error: any) {
      return error;
    }
  },
);

export const getFileROWSignedURLThunk = createAsyncThunk(
  "access/getFileROWSignedURL",
  async ({ document_name }: { document_name: string }) => {
    try {
      const response = await getViewFileROWSignedUrl(document_name);
      return response.data;
    } catch (error: any) {
      return error;
    }
  },
);

export const getFileSignedURLMorthThunk = createAsyncThunk(
  "row/getFileSignedURLMorth",
  async ({ document_name }: { document_name: string }) => {
    const response = await getViewFileSignedUrl(document_name, "morth");
    return response.data;
  },
);

export const getROWFileSignedURLMorthThunk = createAsyncThunk(
  "row/getFileSignedURLMorth",
  async ({ document_name }: { document_name: string }) => {
    const response = await getViewFileROWSignedUrl(document_name, "morth");
    return response.data;
  },
);

export const getDownloadSignedURLThunk = createAsyncThunk(
  "access/getDownloadSignedURL",
  async ({ document_name }: { document_name: string }) => {
    try {
      const response = await getDownloadSignedUrl(document_name);
      return response.data;
    } catch (error: any) {
      return error;
    }
  },
);

export const getDeleteSignedURLThunk = createAsyncThunk(
  "access/getDeleteSignedURL",
  async (fileName: StepIconClassKey) => {
    try {
      const response = await getDeleteSignedUrl(fileName);
      return response.data;
    } catch (error: any) {
      return error;
    }
  },
);

export const getSignedURLListThunk = createAsyncThunk(
  "access/getSignedURLList",
  async () => {
    try {
      const response = await getSignedUrlList();
      return response.data;
    } catch (error: any) {
      return error;
    }
  },
);

export const postSaveUploadedFileThunk = createAsyncThunk(
  "access/postSaveUploadedFile",
  async (payload: any) => {
    try {
      const response = await postSavedUploadedFile(payload);
      return response.data;
    } catch (error: any) {
      return error;
    }
  },
);

export const getUploadedFileByIdThunk = createAsyncThunk(
  "access/getUploadedFileById",
  async (payload: any) => {
    const { access_id, category_id, document } = payload;
    try {
      const response = await getUploadedFileById(
        access_id,
        category_id,
        document,
      );
      return response.data;
    } catch (error: any) {
      return error;
    }
  },
);

export const deleteFileByIdThunk = createAsyncThunk(
  "access/deleteFileById",
  async (payload: any) => {
    const { access_id, document_id } = payload;
    try {
      const response = await deleteFileById(access_id, document_id);
      return response.data;
    } catch (error: any) {
      return error;
    }
  },
);

export const submitDocumentThunk = createAsyncThunk(
  "access/submitDocument",
  async (payload: DocumentsListPayload) => {
    const { access_id, category_id } = payload;
    try {
      const response = await submitDocument(access_id, category_id);
      return response.data;
    } catch (error: any) {
      return error;
    }
  },
);

export const consentFormStepThunk = createAsyncThunk(
  "access/submitDocument",
  async (payload: FormStepPayload) => {
    const { access_id } = payload;
    try {
      const response = await consentFormStep({ application_id: access_id });
      return response.data;
    } catch (error: any) {
      return error;
    }
  },
);
